// extracted by mini-css-extract-plugin
export default {"title":"czUvmy1K","buttonsWrap":"huvjnawe","formOrder":"yF0mATI5","statusCell":"rFcm1Dcl","btn":"Ouohg7hb","popover":"_acEhAe6"};